import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Compra`

export function crearPedido(compra) {
  return http.post(`${API_ENDPOINT}/CrearPedido/`, compra)
}
export function crearPedidoItem(compraItem) {
  return http.post(`${API_ENDPOINT}/CrearPedidoItem/`, compraItem, {
    meta: {
      toastMessage: 'Ocurrió un error al crear el pedido.',
      tipoError: 'compra'
    }
  })
}

export function obtenerPublicacion(idUsuario, idPublicacion) {
  return http.get(`${API_ENDPOINT}/ObtenerPublicacion/${idUsuario}/${idPublicacion}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener la publicación.',
      tipoError: 'compra'
    }
  })
}

export function obtenerPresupuestoItems(idUsuario, idPresupuesto) {
  return http.get(`${API_ENDPOINT}/ObtenerPresupuestoItems/${idUsuario}/${idPresupuesto}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener el presupuesto.',
      tipoError: 'presupuesto'
    }
  })
}

export function buscarSimilaresPorPedido(idPedido) {
  return http.get(`${API_ENDPOINT}/BuscarSimilaresPorPedido/${idPedido}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las publicaciones similares.',
      tipoError: 'compra',
      devolverNull: true
    }
  })
}
